<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <a class="btn" *ngIf="canDownload" [href]="downLoadLink">
    <t-icon name="file_download"></t-icon>
    <span class="text">Télécharger</span>
  </a>

</div>
<!-- /Toolbar -->

<div class="grid">

  <div class="column">

    <div class="panel">
      <h2>
        Sélectionner un rapport
      </h2>

      <table>

        <tbody>
          <tr *ngFor="let report of reports" [ngClass]="{ 'selected': report.id === selectedReport.id }" (click)="onSelect(report)">
            <td name="Rappot">
              {{ report.title }}
            </td>
            <td style="width: 64px;" class="actions">
              <a class="action-btn" *ngIf="report.id === selectedReport.id">
                <t-icon name="check"></t-icon>
              </a>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>

  <div class="column">

    <div class="panel" *ngIf="hasData">
      <h2>
        Données
      </h2>

      <t-financial-data-report [dossier]="dossier" [dossierModel]="dossierModel" (selectedRangeChanged)="onFD_selectedRangeChanged($event)"></t-financial-data-report>
    </div>

  </div>

</div>